const VERIFIER_KEY = 'evo_oauth_code_verifier';
const STATE_KEY = 'evo_oauth_state';
const NEXT_KEY = 'evo_oauth_next';

export function isOAuthConfigured () {
  return Boolean(process.env.VUE_APP_OAUTH_ISSUER && process.env.VUE_APP_OAUTH_CLIENT_ID);
}

export function getOAuthRedirectUri () {
  return process.env.VUE_APP_OAUTH_REDIRECT_URI || `${window.location.origin}/auth/callback`;
}

function base64UrlEncode (buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function randomString (bytes = 32) {
  const array = new Uint8Array(bytes);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

async function sha256 (plain) {
  const data = new TextEncoder().encode(plain);
  return crypto.subtle.digest('SHA-256', data);
}

export async function startEvoIdLogin () {
  if (!isOAuthConfigured()) {
    throw new Error('Вход через ЭВО ID не настроен');
  }
  if (!window.crypto || !window.crypto.subtle) {
    throw new Error('Для входа через ЭВО ID нужен HTTPS');
  }

  const issuer = process.env.VUE_APP_OAUTH_ISSUER.replace(/\/$/, '');
  const clientId = process.env.VUE_APP_OAUTH_CLIENT_ID;
  const redirectUri = getOAuthRedirectUri();
  const verifier = randomString(32);
  const challenge = base64UrlEncode(await sha256(verifier));
  const state = randomString(16);

  sessionStorage.setItem(VERIFIER_KEY, verifier);
  sessionStorage.setItem(STATE_KEY, state);

  const nextPath = window.location.pathname + window.location.search + window.location.hash;
  if (nextPath && nextPath.indexOf('/auth/callback') !== 0) {
    sessionStorage.setItem(NEXT_KEY, nextPath);
  }

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    code_challenge: challenge,
    code_challenge_method: 'S256',
    state,
  });

  window.location.href = `${issuer}/oauth/authorize?${params.toString()}`;
}

export function hasOAuthCallbackParams () {
  const params = new URLSearchParams(window.location.search);
  return params.has('code') || params.has('error');
}

export function consumeOAuthCallback () {
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');
  const errorDescription = params.get('error_description');
  const code = params.get('code');
  const state = params.get('state');
  const expectedState = sessionStorage.getItem(STATE_KEY);
  const verifier = sessionStorage.getItem(VERIFIER_KEY);

  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);

  return {
    error,
    errorDescription,
    code,
    state,
    expectedState,
    verifier,
    redirectUri: getOAuthRedirectUri(),
  };
}

export function consumeOAuthNextPath () {
  const next = sessionStorage.getItem(NEXT_KEY);
  sessionStorage.removeItem(NEXT_KEY);
  return next;
}

export function buildOAuthLogoutUrl () {
  if (!isOAuthConfigured()) {
    return null;
  }

  const issuer = process.env.VUE_APP_OAUTH_ISSUER.replace(/\/$/, '');
  const clientId = process.env.VUE_APP_OAUTH_CLIENT_ID;
  const postLogoutRedirectUri = `${window.location.origin}/`;
  const params = new URLSearchParams({
    client_id: clientId,
    post_logout_redirect_uri: postLogoutRedirectUri,
  });

  return `${issuer}/oauth/logout?${params.toString()}`;
}
